import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useUnit } from 'effector-react';
// Cross-entity auth state is consumed through the auth slice public API.
// eslint-disable-next-line local/no-same-layer-slice-alias-imports
import { $authUserId } from '~/entities/auth';
import { queryKeys } from '~/shared/api/queryKeys';
import { adminPayinOrderServiceGetOrder, getAdminPayinOrderServiceGetOrderUrl } from '~/generated/payinBackend/order';
import { type AdminPayinOrderServiceGetOrderParams } from '~/generated/payinBackend/model';

type QueryOptions<Data> = Omit<UseQueryOptions<Data, Error, Data>, 'queryFn' | 'queryKey'>;
type OrderResponse = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>;

export const useOrder = (params: AdminPayinOrderServiceGetOrderParams, options: QueryOptions<OrderResponse> = {}) => {
    const userId = useUnit($authUserId);
    const { enabled, ...queryOptions } = options;

    return useQuery<OrderResponse>({
        enabled: userId ? enabled : false,
        refetchOnWindowFocus: true,
        queryFn: () =>
            adminPayinOrderServiceGetOrder(params, {
                context: {
                    skipErrorNotification: true,
                },
            }),
        queryKey: [queryKeys.PAYIN_ORDER, userId, getAdminPayinOrderServiceGetOrderUrl(params)],
        ...queryOptions,
    });
};
